// Nombre de la empresa (Configuración → empresa) para firmar los mensajes.
// Se carga una vez al entrar; mientras tanto se usa el de siempre.
import api from './api';
import { datosPrueba } from './instancia';
let nombre = null;
// (en una copia de prueba para un cliente nunca sale el nombre de tu empresa)
export const nombreEmpresa = () => nombre || (datosPrueba() ? 'Mi empresa' : 'iService Reparaciones');
export function cargarEmpresa() {
  if (nombre) return;
  api.get('/configuracion/publica', { silencioso: true })
    .then(r => { nombre = (r.data && r.data.data && r.data.data.empresa_nombre) || null; })
    .catch(() => {});
}
